import { GraphQLService } from './graphql.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Currency } from '../models/currency.model';
import { MatSnackBar } from '@angular/material/snack-bar';

import currenciesQuery from 'src/app/graphql/queries/currencies.query.graphql'

@Injectable()
export class CurrencyService extends GraphQLService<Currency> {
  constructor(
    http: HttpClient,
    snackBar: MatSnackBar
  ) {
    super(http, snackBar)
  }

  getAvailableCurrencies(): Observable<Currency[]> {
    return this.findAll(currenciesQuery)
  }

}
